import dayjs from 'dayjs'
import type { OrderMessageWithUser } from 'src/api/db/apiOrderMessage'

const AUTHOR_COLORS = [
  '#E8912D',
  '#2BAC76',
  '#611F69',
  '#1264A3',
  '#E01E5A',
  '#4A154B',
]

const hashString = (value: string) => {
  let hash = 0
  for (let i = 0; i < value.length; i += 1) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash)
  }
  return Math.abs(hash)
}

export const formatMessageAuthorName = (
  message: OrderMessageWithUser,
  t: (en: string, sv?: string) => string
) => {
  if (message.role === 'system') return t('System', 'System')

  const user = Array.isArray(message.user) ? message.user[0] : message.user
  const userDisplay =
    [user?.first_name, user?.last_name].filter(Boolean).join(' ') || null

  if (message.role !== 'customer') {
    return userDisplay
      ? `${userDisplay} • Team Klayder`
      : t('Team Klayder', 'Team Klayder')
  }

  return userDisplay ?? t('Customer', 'Kund')
}

export const getMessageAuthorInitials = (authorName: string) => {
  const parts = authorName
    .replace('• Team Klayder', '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)

  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase()
  return `${parts[0]![0] ?? ''}${parts[parts.length - 1]![0] ?? ''}`.toUpperCase()
}

export const getMessageAuthorColor = (
  message: OrderMessageWithUser,
  authorName: string
) => {
  if (message.role === 'system') return '#94A3B8'
  if (message.role !== 'customer') return '#611F69'
  return AUTHOR_COLORS[hashString(authorName) % AUTHOR_COLORS.length]!
}

export const formatMessageDateGroup = (createdAt: string) =>
  dayjs(createdAt).format('dddd, MMMM D')

export const formatMessageTimestamp = (createdAt: string) =>
  dayjs(createdAt).format('h:mm A')
